export default {
  init: function () {
    const t = this
    const mainNav = document.querySelector('.main-nav')

    t.header = document.querySelector('.site-header')
    t.body = document.body

    if (!mainNav) return

    t.openCloseMenu()

    t.openSubMenuLists()

    t.stickyHeaderNav()
  },

  openCloseMenu: function () {
    const t = this
    const openMenuBtn = document.getElementById('menu-toggle')

    openMenuBtn.addEventListener('click', () => {
      t.header.toggleAttribute('aria-expanded')
      t.overflowBodyToggle()
    })
  },

  overflowBodyToggle: function() {
    const t = this
    t.body.style.overflow = t.body.style.overflow == 'hidden' ? 'auto' : 'hidden'
    t.body.toggleAttribute('aria-open-menu')
  },

  isExpanded: function () {
    let t = this
    return t.header.hasAttribute('aria-expanded')
  },

  openSubMenuLists: function() {
    const t = this
    const subMenuLinks = document.querySelectorAll('.menu-item-has-children')

    Array.from(subMenuLinks).forEach(subMenuLink => {
      subMenuLink.querySelector('a').addEventListener('click', (e) => {
        e.preventDefault()
        if(t.isExpanded()) {
          subMenuLink.toggleAttribute('aria-active-sub-menu')
        }
      })
    })
  },

  stickyHeaderNav: function() {
    const t = this

    window.addEventListener('scroll', t.stickyNavAction)
  },

  stickyNavAction: function() {
    const nav = document.querySelector('#site-header'),
      OFFSET_SCROLL = 200,
      OFFSET_STICKY = 500,
      scrollingOffset = nav.offsetHeight + OFFSET_SCROLL,
      offsetAttributes = {scrolling: 'header-scrolling', sticky: 'header-sticky'}

    if (window.scrollY >= scrollingOffset && window.scrollY < scrollingOffset + OFFSET_STICKY) {
      nav.setAttribute(offsetAttributes.scrolling, '')
    } else if (window.scrollY >= scrollingOffset + OFFSET_STICKY) {
      nav.setAttribute(offsetAttributes.scrolling, '')
      nav.setAttribute(offsetAttributes.sticky, '')
    } else {
      nav.removeAttribute(offsetAttributes.scrolling)
      nav.removeAttribute(offsetAttributes.sticky)
    }
  },
}
